import { withFlagService } from '@atlassian/jira-flags';
import ManagePagesLinkModal from './view.tsx';

export default withFlagService(ManagePagesLinkModal);
